import React from 'react';
import { PDFViewer, Page, Text, Image, Document, View, StyleSheet } from '@react-pdf/renderer';
import { ADMISION } from './Styles/StylesAdmision';

import logo from "../../assets/img/logo_menu_black.png";
import { formatNumber, formatReconver } from "../../funciones/GeneralFunctions";

const PagosNoAp = (props) => {

    const styles = StyleSheet.create(ADMISION[0]);

    let tipo = (tipo) => {
        if (tipo === "dia") return null;
        let Meses = ["ENERO", "FEBRERO", "MARZO", "ABRIL", "MAYO", "JUNIO", "JULIO", "AGOSTO", "SEPTIEMBRE", "OCTUBRE", "NOVIEMBRE", "DICIEMBRE"]

        return ` - (${Meses[parseInt(props.mes) - 1]})`
    }

    let nombre = (nombre) => {
        if (nombre === null) return "";
        return nombre;
    }

    let asientos = () => {
        if (props.data.length === 0) return (
            <View style={[styles.row]}>
                <Text style={[styles.colTabla10, styles.font9, styles.bordeCol11, {textAlign: "center"}]}>No existen ingresos</Text>
            </View>
        )
        
        return (
            props.data.map(option => (
                <View key={option.id} style={[styles.row]}>
                    <Text style={[styles.colTablaInsc5, styles.font8, styles.bordeCol11, styles.borderTop, styles.center]}>{option.idTrans}</Text>
                    <Text style={[styles.colTablaIngr2, styles.font8, styles.bordeCol9, styles.borderTop, styles.center]}>{option.fecha}</Text>
                    <View style={[styles.colTablaIngr1_1, styles.bordeCol9, styles.borderTop]}>
                        <Text style={[styles.font7, {color: "#b41806"}]}>
                            {`${option.nacionalidad}${option.ci}`}
                        </Text>
                        <Text style={[styles.font7]}>
                            {`${option.nombre_1} ${nombre(option.nombre_2)} ${option.apellido_1} ${nombre(option.apellido_2)}`}
                        </Text>
                    </View>
                    <View style={[styles.colTablaIngr3_1, styles.bordeCol9, styles.borderTop]}>
                        {/* <Text style={[styles.font7]}>Facturado: {formatNumber(option.debe)} Bs. {formatReconver(option.debe)} Bs.</Text>
                        <Text style={[styles.font7]}>Pagado: {formatNumber(option.haber)} Bs. {formatReconver(option.haber)} Bs.</Text> */}
                        <Text style={[styles.font7]}>Facturado: {formatNumber(option.debe)} Bs.</Text>
                        <Text style={[styles.font7]}>Pagado: {formatNumber(option.haber)} Bs.</Text>
                    </View>
                    <Text style={[styles.colTablaIngr2_1, styles.font7, styles.bordeCol9, styles.borderTop, styles.center]}>{option.status}</Text>
                </View>
            ))
        )
    }

    return(
        <PDFViewer style={styles.section}>
            <Document title={props.title}>
                <Page size="letter" style={styles.body}>
                    <View style={styles.row}>
                        <Image
                            style={[styles.colContent40, styles.logo]}
                            src={logo}
                        />
                        <View style={[styles.colContent60, styles.header1Left,{marginTop: 14,}]}>
                            <Text style={[styles.Negrita]}>INSTITUTO UNIVERSITARIO DE DISEÑO LAS MERCEDES</Text>
                            <Text style={[styles.textPeq]}>REGISTRO M.E, Nº 130 G.O. Nº 36.719  9 JUNIO 1.999 | RIF.J-30583313-3</Text>
                        </View>
                    </View>

                    <Text style={[styles.titulo, styles.header1Right, styles.custonMt10, styles.customMl,
                        {fontSize: 14, backgroundColor: "#777", color:"#FFF", padding: 2, borderRadius: 2}]}>
                        {props.title.toUpperCase()} {tipo(props.tipo)}
                    </Text>

                    <View style={[styles.bordeConstancia, {backgroundColor: "#FFF", padding: 4,}]}>
                        <Text style={[styles.font10, {backgroundColor: "#ccc"}]}>I. DETALLES DE LAS TRANSACCIONES</Text>
                        <View style={[{paddingLeft: 5, paddingTop: 5, backgroundColor: "#fff"}]}>
                            <View style={[styles.row]}>
                                <Text style={[styles.col3, styles.font8]}>MOSTRANDO {props.data.length} REGISTROS</Text>
                            </View>
                        </View>
                    </View>

                    <View style={[styles.bordeConstancia, {marginTop: 5, backgroundColor: "#FFF", padding: 4,}]}>
                        <Text style={[styles.font10, {backgroundColor: "#ccc"}]}>II. LISTADO DE {props.title.toUpperCase()}</Text>
                        <View style={[{paddingLeft: 5, paddingTop: 5, backgroundColor: "#fff"}]}>
                            <View style={[styles.row]}>
                                <Text style={[styles.colTablaInsc5, styles.font9, styles.bordeCol11, styles.borderTop, {textAlign: "center", backgroundColor: "#777", color:"#FFF"}]}>N°</Text>
                                <Text style={[styles.colTablaIngr2, styles.font9, styles.bordeCol9, styles.borderTop, styles.center, {backgroundColor: "#777", color:"#FFF"}]}>FECHA</Text>
                                <Text style={[styles.colTablaIngr1_1, styles.font9, styles.bordeCol9, styles.borderTop, styles.center, {backgroundColor: "#777", color:"#FFF"}]}>ESTUDIANTE</Text>
                                <Text style={[styles.colTablaIngr3_1, styles.font9, styles.bordeCol9, styles.borderTop, styles.center, {backgroundColor: "#777", color:"#FFF"}]}>DETALLES</Text>
                                <Text style={[styles.colTablaIngr2_1, styles.font9, styles.bordeCol9, styles.borderTop, styles.center, {backgroundColor: "#777", color:"#FFF"}]}>MOTIVO</Text>
                            </View>
                            {asientos()}
                        </View>
                    </View>

                    {/* <View style={[styles.footer]}>
                        <View style={[styles.row]}>
                            <View style={[styles.col6]}>
                            <Text style={[styles.linea3]}></Text>
                                <Text style={[styles.encabezado2]}>
                                    Av. Río de Janeiro con Calle Roraima, quinta Los Abuelos, N° 78, Urbanización Chuao, 
                                    C.P.1061  Edo Miranda - Caracas - Venezuela
                                </Text>
                                <Text style={[styles.encabezado2, {marginTop: -5}]}>
                                    Telefax: +58 212 9930983 | 9939139 | 9910710.
                                </Text>
                            </View>
                        </View>
                    </View> */}
                </Page>
            </Document>
        </PDFViewer>
    )
}

export default PagosNoAp;


// WEBPACK FOOTER //
// ./src/components/Reportes/PagosNoAp.jsx